import { render } from "./LinksFooter.vue?vue&type=template&id=6e614c20&scoped=true"
const script = {}

import "./LinksFooter.vue?vue&type=style&index=0&id=6e614c20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e614c20"]])

export default __exports__